import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { ScheduleLessonComponent } from '../../schedule/schedule-lesson/schedule-lesson.component';
import { Message } from '../../../interfaces/message';
import { FiltersColorHelper } from 'src/app/utils/helpers/filtersColorHelper';

@Component({
  selector: 'app-day-schedule-lesson',
  templateUrl: './day-schedule-lesson.component.html',
  styleUrls: ['./day-schedule-lesson.component.scss', './day-schedule-lesson.component.en.scss']
})
export class DayScheduleLessonComponent extends ScheduleLessonComponent implements OnInit {
  @Input() notificationsHeaderText: string = "";
  @HostBinding('class.single-line') get singleLine() {
    return !((this.lesson.timeEnd - this.lesson.timeStart) > 1);
  };
  @HostBinding('class.canceled') get canceledLesson() {
    return this.lesson.canceled;
  };
  openedNotifications: boolean = false;
  openedDetails: boolean = false;
  color: string = '';
  secondaryColor: string = '';

  FiltersColorHelper = FiltersColorHelper;

  ngOnInit() {
    this.color = this.lesson.color ?? FiltersColorHelper.defaultColor;
    this.secondaryColor = FiltersColorHelper.rgba(this.color, 0.1);
  }

  openNotifications(e?: Event) {
    if (!this.canceledLesson) {
      if(e) e.preventDefault();

      this.openedNotifications = true;
    }
  }

  openDetails(e: Event) {
    if (!this.canceledLesson) {
      e.preventDefault();

      this.openedDetails = true;
    }
  }

  closeDetails() {
    this.openedDetails = false;
  }

  closeNotifications() {
    this.openedNotifications = false;
  }

  convertDecimalToTimeString(decimal: number): string {
    let hours = Math.floor(decimal);
    let minutes = Math.round((decimal - hours) * 60);

    let formattedHours = hours.toString().padStart(2, '0');
    let formattedMinutes = minutes.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}`;
  }
}
